<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-sm-12">
    <Transition name="fade">
      <div
        v-if="storageList.length > 0"
        class="list-content result-table pointer"
      >
        <vue3-datatable
          ref="resultTable"
          :rows="storageList"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          :height="storageList.length > 8 ? '35em' : '100%'"
          :sortable="true"
          skin="bh-table-compact"
          :row-class="getRowClass"
          cell-class="routa-table-cell"
          :has-checkbox="true"
          @row-click="rowClicked"
          @row-select="onRowSelect"
        >
            <template #active="row">
                <div v-if="row.value.active" class="col-12 d-flex justify-content-center nopads" style="color: #7FC000">
                    <i class="fa fa-check"></i>
                </div>
            </template>
        </vue3-datatable>
      </div>
    </Transition>
  </div>
</template>

<script>


import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'MaterialStorageList',
    components: {Vue3Datatable},
    props: {
        storages: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            storageList: [],
            selectedRows: [],
            selectedRowId: null,
            selectedIndex: null
        }
    },
    computed: {
        fields() {
            return [
                {field: 'id', title: this.$t('materialstorage.list.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'name', title: this.$t('materialstorage.list.name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'active', title: this.$t('materialstorage.active'), sort: false, headerClass: 'routa-table-header'}]
        }
    },
    watch: {
        storages() {
            this.storageList = []
            this.$nextTick(() => {
                this.storageList = this.storages
                this.$nextTick(() => {
                    this.restoreRowsSelection()
                })
            })
        }
    },
    mounted() {
        this.storageList = this.storages
    },
    methods: {
        rowClicked: function (details) {
            this.$emit('rowClicked', details)
        },
        scrollToSelected() {
            let rowElement
            if (this.selectedRowId) {
                rowElement = document.querySelector(`.row-id-${this.selectedRowId}`)
                if (!rowElement) {
                    // Check if we have something in the index - observation closing case -> need to return to same place in list
                    if (this.selectedIndex && this.selectedIndex >= 0) {
                        this.selectedIndex = Math.min(this.selectedIndex, this.results.length)
                        const scrollId = this.storages[this.selectedIndex].id
                        rowElement = document.querySelector(`.row-id-${scrollId}`)
                    }
                }
            }
            if (rowElement) {
                rowElement.scrollIntoView({ behavior: 'auto', block: 'center' })
            } else {
                this.resetSelection()
            }
        },
        setSelection(index) {
            this.selectedRowId = null
            if (index >= 0 && index < this.storages.length) {
                this.selectedRowId = this.storages[index].id
            }
        },

        resetSelection() {
            this.selectedRowId = null
            this.selectedIndex = null
            this.$refs.resultTable?.clearSelectedRows()
        },
        getRowClass(row) {
            return row.id === this.selectedRowId ? 'routa-table-row selected-row row-id-' + row.id : 'routa-table-row  row-id-' + row.id
        },
        onRowSelect(selectedRows) {
            if (this._syncingSelection) return
            const selectedIds = selectedRows.map(r => r.id)
            const originalItems = this.storages.filter(a => selectedIds.includes(a.id))
            this.selectedRows = originalItems
            this.$emit('row-select', originalItems)
        },
        restoreRowsSelection() {
            if (this.selectedRows && this.selectedRows.length > 0) {
                this.$nextTick(() => {
                    const indexes = this.selectedRows.map(row => this.storages.findIndex(item => item.id === row.id));
                    indexes.forEach(idx => this.$refs.resultTable.selectRow(idx))
                })
            }
        },
    }
}
</script>
